<ngx-loading [show]="loading" [config]="{ backdropBackgroundColour: 'rgba(0,0,0,0.6)' }" #customLoadingTemplate></ngx-loading>
<p *ngIf="!orderServiceResumes && !loading"><em>Sem dados</em></p>

<div *ngIf="orderServiceResumes" class="containerSearchTxtOrder" style="margin-bottom: 7px; margin-top: -9px;">
  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading" (click)="refrehPage()">
    <img title="Atualizar" style="cursor: pointer; cursor: pointer; height: 24px; width: 24px; cursor: inherit; margin-right: 15px;" src="/update.svg" />
  </button>

  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading">
    <img title="Buscar" style="height: 24px; width: 24px; cursor: inherit; margin-right: 5px;" src="/search.svg" />
  </button>

  <input type="text" (ngxInputSearch)="doSearch($event)"
         (emptyInput)="doSearchClear()"
         stringLength="0" class="searchTxt" placeholder="" disabled />
</div>

<table class='table table-striped table-without-width' aria-labelledby="tableLabel" align="center" *ngIf="orderServiceResumes">
  <thead>
    <tr>
      <th style="text-align:center; width: 125px !important">Data</th>
      <th style="text-align:center;">Instalações vendidas</th>
      <th style="text-align:center;">Instalações faturadas</th>
      <th style="text-align:center;">Instalações canceladas</th>
      <th style="text-align:center; width: 100px !important"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let orderServiceResumeItem of orderServiceResumes | paginate: { id: 'OrderServiceResume', itemsPerPage: pageSize, currentPage: p, totalItems: total }; let i = index">
      <td style="text-align:center;" title="{{ orderServiceResumeItem.dateResumeServicesFormated }}">{{ orderServiceResumeItem.dateResumeServicesFormated }}</td>
      <td style="text-align:center;" title="{{ orderServiceResumeItem.countServices }}">{{ orderServiceResumeItem.countServices }}</td>
      <td style="text-align:center;" title="{{ orderServiceResumeItem.countServicesInvoiced }}">{{ orderServiceResumeItem.countServicesInvoiced }}</td>
      <td style="text-align:center;" title="{{ orderServiceResumeItem.countServicesCanceled }}">{{ orderServiceResumeItem.countServicesCanceled }}</td>
      <td style="text-align:center;">
        <button class="btn btn-outline" style="border-color: transparent !important;" [disabled]="loading" (click)="openModal('modalDetailOrderServices', i, $event)">
          <img style="cursor: pointer; border-radius: 20px;" src="/detail.svg" class="btn-img-nocircle details" />
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="11">
        <pagination-controls id="OrderServiceResume"
                             (pageChange)="pageChanged($event)"
                             (pageBoundsCorrection)="pageChanged($event)"
                             maxSize="9"
                             directionLinks="true"
                             autoHide="true"
                             responsive="true"
                             previousLabel="anterior"
                             nextLabel="próximo"
                             screenReaderPaginationLabel="Paginação"
                             screenReaderPageLabel="pagina"
                             screenReaderCurrentLabel="você esta na página">
        </pagination-controls>
      </td>
    </tr>
  </tfoot>
</table>

<!--Details Modal-->
<div class="container container-service">
  <div class="modal" id="modalDetailOrderServices" role="dialog">
    <div class="modal-dialog modal-dialog-service">
      <div class="modal-content">
        <div class="modal-body modal-body-service">
          <div class="row" *ngIf="orderServiceResume">

            <div class="col-12 ml-5" style="font-weight: bold; color: #52ae32 !important; font-size: 18px; margin-bottom: 20px;">
              Dia {{ orderServiceResume.dateResumeServicesFormated }}
            </div>

            <!--Instalações faturadas-->
            <div class="col-12">
              <div class="col-12 ml-5" style="font-weight: 500;">
                Instalações faturadas
              </div>

              <table class='table ml-5 table-modal-service' align="center">
                <thead>
                  <tr>
                    <th style="width: 15%; text-align:left; border: none !important">OV</th>
                    <th style="width: 15%; text-align:left; border: none !important">Hora de criação</th>
                    <th style="width: 15%; text-align:left; border: none !important">Valor</th>
                    <th style="width: 65%; text-align:left; border: none !important">Descrição do serviço</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let orderServiceInvoiced of orderServiceResume.listOrderServiceInvoiced; let i = index" style="background: transparent;">
                    <td style="text-align: left; border: none !important;">{{ orderServiceInvoiced.salesId }}</td>
                    <td style="text-align: left; border: none !important;">{{ orderServiceInvoiced.createdHourFormated }}</td>
                    <td style="text-align: left; border: none !important;">{{ orderServiceInvoiced.amountFormated }}</td>
                    <td style="text-align: left; border: none !important; white-space: normal;">{{ orderServiceInvoiced.description }}</td>
                  </tr>
                </tbody>
              </table>

            </div>

            <hr style="border: 1px solid #52ae32; margin: 0px 30px 30px 30px; box-sizing: border-box; width: 100%; " />

            <!--Instalações canceladas-->
            <div class="col-12">
              <div class="col-12 ml-5" style="font-weight: 500;">
                Instalações canceladas
              </div>
              <table class='table ml-5 table-modal-service' align="center">
                <thead>
                  <tr>
                    <th style="width: 15%; text-align:left; border: none !important">OV</th>
                    <th style="width: 15%; text-align:left; border: none !important">Hora de criação</th>
                    <th style="width: 15%; text-align:left; border: none !important">Valor</th>
                    <th style="width: 65%; text-align:left; border: none !important">Descrição do serviço</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let orderServiceCanceled of orderServiceResume.listOrderServiceCanceled; let i = index" style="background: transparent;">
                    <td style="text-align: left; border: none !important;">{{ orderServiceCanceled.salesId }}</td>
                    <td style="text-align: left; border: none !important;">{{ orderServiceCanceled.createdHourFormated }}</td>
                    <td style="text-align: left; border: none !important;">{{ orderServiceCanceled.amountFormated }}</td>
                    <td style="text-align: left; border: none !important; white-space: normal;">{{ orderServiceCanceled.description }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <hr style="border: 1px solid #52ae32; margin: 0px 30px 30px 30px; box-sizing: border-box; width: 100%; " />

          </div>
        </div>
        <div class="modal-footer modal-footer-tracking">
          <button class="btn btn-outline" [disabled]="loading" (click)="closeModal('modalDetailOrderServices')">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</div>

